/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectIcon16Light = forwardRef('CommentRectIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 4.5A2.5 2.5 0 0 1 3.5 2h8A2.5 2.5 0 0 1 14 4.5v6a2.5 2.5 0 0 1-2.5 2.5H8.151l-3.907 2.605A.8.8 0 0 1 3 14.94V12.95a2.5 2.5 0 0 1-2-2.45v-6ZM3.5 3A1.5 1.5 0 0 0 2 4.5v6A1.5 1.5 0 0 0 3.5 12a.5.5 0 0 1 .5.5v2.066l3.723-2.482A.5.5 0 0 1 8 12h3.5a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 11.5 3h-8Z" })));
});
